//import './styles/fonts.css';
import './styles/index.css';
import 'swiper/css';

import './js/anims';
import './js/menu';
import './js/more-less';
import './js/no-widows';
import './js/topbar';
import './js/smoothscroll';
import './js/simplebar';
import './js/videolist';

if (document.querySelectorAll(".swiper").length > 0) {
  import('./js/swiper').then(({ initSwiper }) => {
    initSwiper();
  });
}

if (document.querySelector("[data-galeria-trigger]")) {
  import('./js/gallery-popup').then(({ initGalleryPopup }) => {
    initGalleryPopup();
  });
}

if (document.querySelector("#app-fb")) {
  import('./js/newsfb').then(({ initNewsfb }) => {
    initNewsfb();
  });
}
